export default {
  title: 'Furnizorul dvs. gestionează acest pas',
  description: {
    payments: 'Contactați {{partner}} pentru a configura plățile online.',
    go_live: 'Contactați {{partner}} pentru a activa restaurantul.',
  },
  fallback_partner: 'furnizorul dvs.',
};
